<script lang="ts">
  import HomeContainer from "app/components/widget/home/HomeContainer.svelte";
  import { onMount } from "svelte";
  import { community } from "app/stores/community";
  import { createNewConversation } from "app/stores/widget";

  onMount(() => {
    createNewConversation();
  });
</script>

<HomeContainer
  logo={$community.widgetLogo}
  data={$community}
  customAction={{
    label: $community.widgetCustomActionLabel ?? "",
    prompt: $community.widgetCustomActionPrompt ?? "",
  }}
  isChromeExtension={false}
/>
